module.exports = __webpack_public_path__ + "static/img/info-for-get-app.54eed48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/info-for-get-app.svg
// module id = 7vJI
// module chunks = 1